<template>
    <v-card class="m-4">
        <v-alert v-if='get_error_brigades'
            type="warning"
        >Выберите сначала бригаду!</v-alert>
        <template v-if="get_statistics == null">
            <v-card-title>
                <h2>Пока новых планов нет</h2>
            </v-card-title>
        </template>
        <template v-else>
            <v-card-title>
                <h2>Фактически произвели на {{ formated_date(get_statistics.date) }} г.</h2>

            </v-card-title>
            <!-- <v-card-title>

                <h3>Бригада - {{selected_brigade.hasOwnProperty('name') ? selected_brigade.name : 'Не выбрана'}}; Количество человек - {{selected_brigade.hasOwnProperty('quantity') ?selected_brigade.quantity : 0 }}</h3>
            </v-card-title> -->

            <v-card-text>
                <v-container fluid>
                    <template v-if="title == 'master' || title == 'admin'">
                        <template v-if="get_statistics.status == 'open'">

                            <div class='buttons mb-4'>

                                <v-btn color="warning" dark @click="close(get_statistics._id)" class="mr-2"
                                    >Закрыть смену</v-btn
                                >

                                <!-- <v-dialog v-model="group" persistent width="80vw">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn color="warning" dark v-bind="attrs" v-on="on">Выбрать бригаду</v-btn>

                                        </template>

                                        <v-card>

                                            <v-card-title>
                                                <span class="headline">Выбор бригады</span>
                                            </v-card-title>

                                            <v-card-text>
                                                <v-container>
                                                    <v-row>
                                                        <v-col cols="6" sm="6" md="6">
                                                            <v-select
                                                                v-model="selected_brigade"
                                                                :items="brigades"
                                                                item-text="name"
                                                                item-value="type"
                                                                label="Выберите бригаду*"
                                                                persistent-hint
                                                                return-object
                                                                single-line
                                                            ></v-select>
                                                        </v-col>
                                                        <v-col cols="6" sm="6" md="6">
                                                            <v-text-field label="Количество человек в бригаде" min="1" type="number" required v-model="selected_brigade.quantity"></v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                </v-container>
                                            </v-card-text>

                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn color="blue darken-1" text @click="hide_modal()">Закрыть</v-btn>
                                                <v-btn color="warning" dark @click="save_brigade()">Сохранить</v-btn>
                                            </v-card-actions>

                                        </v-card>
                                </v-dialog> -->

                            </div>
                        </template>
                        <template v-else>
                            <v-btn color="warning" disabled class="mb-4"> Смена закрыта </v-btn>
                        </template>
                    </template>
                    <div class="groups-grid">
                        <ProductGroup
                            v-for="group in get_statistics.groups"
                            :key="group._id"
                            :group="group"
                            :fact="true"
                            :_id="get_statistics._id"
                            :status="get_statistics.status"
                            :brigade_count_users="selected_brigade.quantity"
                            :brigade_selected="selected_brigade"
                            @error="xx = true"
                        />
                    </div>
                </v-container>
            </v-card-text>
        </template>
    </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import ProductGroup from '@/components/products/ProductGroup.vue'
import axios from 'axios'
import uri from '../store/config'
import login from '@/views/Login.vue'

export default {
    name: 'SetFact',
    data: () => ({
        title: localStorage.getItem('title'),
        brigades : [],
        group: false,
        selected_brigade : {},
        old_selected_brigade : {},
        xx: false
        // brigade_count_users: 0,
        // brigade_selected: null
    }),
    components: {
        ProductGroup,
    },
    computed: {
        ...mapGetters(['get_statistics', 'get_error_brigades']),
    },
    created() {
        this.load_statistics_by_authenticate()
    },
    async beforeMount() {
        await this.get_brigades()
    },
    methods: {
        ...mapActions(['load_statistics_by_authenticate', 'close_statistic']),

        close(_id) {
            this.close_statistic({ _id })
            this.load_statistics_by_authenticate()
        },
        formated_date(date) {
            return new Date(date).toLocaleDateString('ru-RU')
        },

        async get_brigades(){
            const instance = await axios.create({
                baseURL: uri,
                headers: {
                    "Content-Type": "application/json",
                    "X-token": localStorage.getItem("_token"),
                    title: localStorage.getItem("title"),
                    _id: localStorage.getItem("_id"),
                },
            });

            instance
                .get(`/brigades/list`)
                .then((res) => {

                    this.brigades = res.data.map(d => {

                        return {
                            ...d,
                            name: d.brigade?.name,
                        }
                    })
                    const exist_selected = this.brigades.find(b => b.selected)

                    if(exist_selected) {
                        this.selected_brigade = exist_selected
                        this.old_selected_brigade = JSON.parse(JSON.stringify(exist_selected))
                    }


                    // if(res.status == 200){
                    //   commit(SET_ARCHIVE, res.data.archive);
                    //   commit(SET_TOTALS_MONTH, res.data.totals);
                    // }



                })
                .catch((err) => {
                    console.log(err)
                });
        },
        hide_modal(){
            this.group = false
            this.selected_brigade = JSON.parse(JSON.stringify(this.old_selected_brigade))

        },
        async save_brigade(){
            if(!this.selected_brigade.name || !this.selected_brigade.quantity || !this.selected_brigade.date){
                return false
            }
            const instance = await axios.create({
                baseURL: uri,
                headers: {
                    "Content-Type": "application/json",
                    "X-token": localStorage.getItem("_token"),
                    title: localStorage.getItem("title"),
                    _id: localStorage.getItem("_id"),
                },
            });

            instance
                .put(`/brigades/update/${this.selected_brigade._id}`, this.selected_brigade)
                .then((res) => {

                    this.old_selected_brigade =  JSON.parse(JSON.stringify(this.selected_brigade))
                    this.group = false

                })
                .catch((err) => {
                    console.log(err)
                });
        },
    },
}
</script>

